if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      if (!this.form.reportValidity()) return;

      this.handleErrorMessage();
      this.error = false;
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') {
          this.cart.setActiveElement(document.activeElement);
        }
      }
      config.body = formData;
      let productAdded = false;

      fetch(window.routes.cart_add_url, config)
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
          }
          return data;
        })
        .then((response) => {
          productAdded = true;
          if (!this.cart || typeof this.cart.renderContents !== 'function') {
            this.handleErrorMessage('Ürün sepetinize eklendi. Sepeti açmak için üstteki sepet simgesine tıklayın.');
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response); });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((error) => {
          console.error(error);
          this.handleErrorMessage(productAdded
            ? 'Ürün sepetinize eklendi ancak sepet paneli açılamadı. Üstteki sepet simgesine tıklayın.'
            : (error.message || 'Sepete ekleme sonucu doğrulanamadı. Tekrar denemeden önce sepetinizi kontrol edin.'));
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (productAdded && this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
